module.exports = __webpack_public_path__ + "img/cleanup4-7-8-2021.2ac7ebf4.jpg";